import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-emptyaddresses',
  templateUrl: './emptyaddresses.component.html',
  styleUrl: './emptyaddresses.component.scss'
})
export class EmptyaddressesComponent {
  isCreateOrder = false;
  constructor(

    private _router: Router,

  ) {

  }
  ngOnInit(): void {


    if (this._router.url === '/Addorderclient') {
      this.isCreateOrder = true;
    }
  }
}
